module.exports = __webpack_public_path__ + "static/media/x-font.e06f63f3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/resources/fonts/x-font.ttf?53940796
// module id = 372
// module chunks = 0